<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.35986 10.5158L11.4405 14.5968C11.7502 14.9062 12.2517 14.9062 12.5613 14.5968L16.6424 10.5158C16.9513 10.2065 16.9513 9.70445 16.6424 9.39524C16.3332 9.08603 15.8309 9.08603 15.5216 9.39524C15.5216 9.39524 13.1194 11.7977 12.0012 12.916C10.8825 11.7977 8.48024 9.39524 8.48024 9.39524C8.17099 9.08603 7.66868 9.08603 7.35986 9.39524C7.05062 9.70445 7.05062 10.2065 7.35986 10.5158Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'DropSmall'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
